const structuredCloneExport = globalThis.structuredClone;

export { structuredCloneExport as structuredClone };
